import React, { useEffect, useState } from 'react';
import {useSelector} from 'react-redux';
import {useAppDispatch} from '../../hooks/redux';

import {
    Autocomplete as AlchemyAutocomplete,
    Input as AlchemyInput,
    Switch as AlchemySwitch,
    Label as AlchemyLabel
} from '@amzn/alchemy-components-react';

import { store } from '../../store/index';
import { setBookmarkCards } from "../../slices/bookmarkCardsSlice"
import { setFilterTerm } from "../../slices/bookmarkFilterSlice"
import { setLoading } from '../../slices/loadingSlice';
import { toggleChecked } from '../../slices/showSiteFavOnlySlice';
import { BookmarksApiService } from '../../api';
import i18n from "../../i18n";
import { RootState } from '../../types';

export default function() {
    const dispatch = useAppDispatch();
    const currentUser = useSelector((state: RootState) => state.user);
    const showSiteFavOnly = useSelector((state: RootState) => state.showSiteFavOnly)
    const bookmarkCards = useSelector((state: RootState) => state.bookmarkCards)
    const siteFavourites = useSelector((state: RootState) => state.siteFavourites)
    const searchBarPlaceholder = showSiteFavOnly ? i18n.t('table:search-for-site') : i18n.t('table:search-for-all')
    const switchLabel = showSiteFavOnly ? `${currentUser.whid} ${i18n.t('table:bookmarks-only')}` : i18n.t('table:search-for-all')
    const originalCardData = showSiteFavOnly ? siteFavourites : bookmarkCards

    const [autoCompleteOptions, setAutoCompleteOptions] = useState([{label:'', value:''}])
    const handleSuggesstion = () => {
        const bookmarkSuggestion = originalCardData.map((bmk: { title?: string, description?: string, entity: string }) => ({label:bmk.title || bmk.description, value:bmk.entity}))
        setAutoCompleteOptions(bookmarkSuggestion)
    }

    useEffect(() => {handleSuggesstion()}, [originalCardData])

    // dispatch search term
    const handleAutoCompleteChanged = (filterTermValue: string) => {
        dispatch(setFilterTerm(filterTermValue))
    }

    const handleToggleClick = (e: React.ChangeEvent<HTMLInputElement>) => {
        dispatch(toggleChecked(e.target.checked))
    }

    async function searchBookmark (searchTerm: string) {
        const bmkApi = new BookmarksApiService()
        const response = await bmkApi.getBookmarksByTitle(searchTerm)
        
        // First cast to unknown, then to our expected response format
        // This handles the case where the API returns an HttpResponse wrapper
        const responseData = (response as any).data || response;
        
        console.log("API Search Response:", responseData);
        
        try {
            // Check if there's an error message and if bookmarks exist
            if (responseData.error_msg && !responseData.bookmarks) {
                console.error("Bookmark search error:", responseData.error_msg);
                dispatch(setBookmarkCards([])); // Set empty array if error occurs
            } else if (Array.isArray(responseData.bookmarks)) {
                // Validate that bookmarks array contains valid bookmark objects
                const validBookmarks = responseData.bookmarks.filter((bookmark: any) => {
                    const isValid = bookmark && typeof bookmark === 'object' && bookmark.entity;
                    if (!isValid) {
                        console.warn('Invalid bookmark object found:', bookmark);
                    }
                    return isValid;
                });
                
                console.log(`Dispatching ${validBookmarks.length} valid bookmarks to Redux store`);
                dispatch(setBookmarkCards(validBookmarks));
                
                // Verify that state was updated by checking current state
                setTimeout(() => {
                    const currentBookmarkCards = store.getState().bookmarkCards;
                    console.log("Updated bookmarkCards state:", currentBookmarkCards);
                    console.log("State update successful:", currentBookmarkCards === validBookmarks);
                }, 0);
            } else {
                console.error("Invalid bookmark response format");
                dispatch(setBookmarkCards([])); // Set empty array for invalid response
            }
        } catch (error) {
            console.error("Error processing bookmark response:", error);
            dispatch(setBookmarkCards([])); // Set empty array if processing error occurs
        }
    }

    const _handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter') {
            dispatch(setLoading(true));
            searchBookmark((e.target as HTMLInputElement).value)
            //Error: Actions must be plain objects. Use custom middleware for async actions.
                .catch(() => {})
                .then(() => {dispatch(setLoading(false))})
        }
    }

    const handleInput = (e: React.SyntheticEvent) => {
        const input = (e.target as any)._typedValue
        if (input.length === 0) {
            dispatch(setFilterTerm(''))
        }
    }

    const filterInput = <AlchemyAutocomplete
        label=""
        placeholder={searchBarPlaceholder}
        clickOpen
        maxHeight="280px"
        options={autoCompleteOptions}
        // select for filtering
        onChange={(e) => handleAutoCompleteChanged(e.target.value)}
        onInput={handleInput}
        trigger={2}
        noOptionsLabel={i18n.t('universal:no-options')} />

    const searchInput = <AlchemyInput
        label=""
        className='flex-grow-1'
        search
        placeholder={searchBarPlaceholder}
        onKeyDown={_handleKeyDown} />

    const input = showSiteFavOnly ? filterInput : searchInput

    return (
        <>
            {/* TODO: Find a better solution to allow autocomplete shows all placeholder */}
            <div className="d-flex" style={{"width": "300px"}}>
                {input}
            </div>
            {/* TODO disable filter while doing search? */}
            <div className="d-flex ml-2"><AlchemySwitch checked={showSiteFavOnly} onChange={(e) => handleToggleClick(e)} /></div>
            <div className="d-flex ml-1"><AlchemyLabel>{switchLabel}</AlchemyLabel></div>
        </>
    )
}
